import PropTypes from 'prop-types'
import Header from './Header'
import StickyLocationSelector from './StickyLocationSelector'
import FacilityModalWrapper from '../modals/FacilityModalWrapper'

/**
 * TraditionalDashboardLayout Component
 *
 * Layout for the traditional dashboard with minimal header style
 * Includes:
 * - Minimal header (matches AI Dashboard and Narrative Dashboard)
 * - Secondary navigation bar (Category and View selectors - rendered in Dashboard)
 * - Sticky location selector (appears on scroll)
 * - Facility modal wrapper
 */
function TraditionalDashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <StickyLocationSelector />
      <main className="container mx-auto px-4 py-6">{children}</main>
      <FacilityModalWrapper />
    </div>
  )
}

TraditionalDashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default TraditionalDashboardLayout
